import React from "react";
import editGif from "../../assets/gif/edit.gif";
const ActiveDeactiveStatusModal = ({
  show,
  onHide,
  UpdatedStatus,
  modelRequestData,
  setIsAddUpdateActionDone,
}) => {
  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        aria-hidden={!show}
      >
        <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-md mx-auto flex flex-col mt-10">
          {/* Modal Header */}
          <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
            {/* Title */}
            <h2 className="text-lg font-bold text-gray-700">
              {" "}
              {/* Your Title Here */}
              {modelRequestData.Action === "SourceStatus"
                ? "Source status"
                : modelRequestData.Action === "MidcStatus"
                  ? "IDC status"
                  : modelRequestData.Action === "UnitStatus"
                    ? "Units status"
                    : modelRequestData.Action === "StateStatus"
                      ? "State status"
                      : modelRequestData.Action === "DistrictStatus"
                        ? "District status"
                        : modelRequestData.Action === "TalukaStatus"
                          ? "Taluka status"
                          : modelRequestData.Action === "DescriptionStatus"
                            ? "Designation status"
                            : modelRequestData.Action === "SentStatus"
                              ? "Sent Status" : modelRequestData.Action === "RoleStatus" ? 'Role Status' : 'Change Status'}
            </h2>

            {/* Close Button */}
            <button
              className="text-gray-500 hover:text-gray-800"
              onClick={onHide}
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Scrollable Content */}
          <div
            className="container mx-auto p-5 overflow-y-auto flex-grow"
            style={{ maxHeight: "60vh" }}
          >
            <div className="flex flex-col">
              <div className="gifAndText flex flex-col items-center">
                <img
                  src={editGif}
                  trigger="loop"
                  colors="primary:#f7b84b,secondary:#f06548"
                  style={{ width: "85px", height: "50px" }}
                />

                {/* <img src={editGif} trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: '85px', height: '50px' }} /> */}
                <label className="mt-3">
                  <b className="text-center">
                    Are you sure you want to change the status?
                  </b>
                </label>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="flex justify-center gap-4 p-4 border-t sticky bottom-0 bg-white z-25">
            <button
              className="btn btn-primary actionBtn"
              onClick={() => UpdatedStatus()}
            >
              Yes! Change It.
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveDeactiveStatusModal;
